import React from "react";
import { Box, Text, Flex, List, ListItem, Icon } from "@chakra-ui/react";
import { MdWarningAmber } from "react-icons/md";

/** Map of API error messages to user-friendly French translations */
const errorMap = {
    'already declined': 'Réservation déja decliné.',
    'An invalid request occurred.': "Cette fiche KantoBiz n'autorise pas la prise de contact.",
    '404 Not Found: The requested URL was not found on the server': 'Lien non trouver.',
    'stripe_token: Not a valid mapping type.': 'Cartographie stripe invalide.',
    'You Are logout, reconnect you please': "Vous êtes déconnecté, reconnectez-vous s'il vous plaît.",
    'card_declined': 'Le paiement a été refusé.',
    'Invalid or lower proposition': 'Le montant proposé est non valide.',
    'Activate your account': 'Veuillez activer votre compte.',
    'Invalid password': 'E-mail ou mot de passe incorrect.',
    'Invalid email or password': 'E-mail ou mot de passe incorrect.',
    'service not found': 'La fiche KantoBiz est introuvable.',
    'authentication_required': "Besoin d'authentification.",
    'reservation not found or not passed yet': 'Réservation introuvable ou pas encore validée',
    'The event date can only be greater than today': "Date d'événement non possible.",
    'new_proposition not found or proposition than lower': 'Votre proposition est inférieur au montant de départ.',
};

/** List of payout failure reasons displayed to the user */
const payoutReasons = [
    "Le compte bancaire n'a pas pu être localisé.",
    "Le compte bancaire du client a été clôturé.",
    "Vous avez informer votre banque que ce paiement n'était pas autorisé.",
];

/**
 * Builds the JSX content for a payout failure error message.
 * @returns {React.ReactElement} Error box with listed reasons
 */
function buildPayoutErrorContent() {
    return (
        <Box>
            <Flex align="center" gap="4px" fontSize="sm">
                Erreur lors du tranfert <Icon as={MdWarningAmber} boxSize="18px" />
            </Flex>
            <Text fontSize="sm" color="gray.500">
                Voici quelques raisons énumérées :
            </Text>
            <List spacing="2px" mt="4px">
                {payoutReasons.map((reason, idx) => (
                    <ListItem key={idx} fontSize="xs">{reason}</ListItem>
                ))}
            </List>
        </Box>
    );
}

/**
 * Translates an API error message into a user-friendly French error object.
 * @param {string} message - Raw API error message
 * @returns {Object} Object with { error: boolean, message: string|ReactElement }
 */
function ErrorMsg(message) {
    if (message === 'payout failed') {
        return { error: true, message: buildPayoutErrorContent() };
    }
    const translated = errorMap[message];
    if (translated) {
        return { error: true, message: translated };
    }
    return { error: true, message: message };
}

export default ErrorMsg;
